document.addEventListener('DOMContentLoaded', function () {
  function initKsProductMediaLoaders(scope) {
    var roots = (scope || document).querySelectorAll('[data-product-images]');

    roots.forEach(function (root) {
      if (root.hasAttribute('data-ks-media-loader-bound')) return;
      root.setAttribute('data-ks-media-loader-bound', 'true');

      var zone = root.querySelector('.ks-product-media-zone');
      var slideshow = root.querySelector('[data-product-photos]');
      if (!zone || !slideshow) return;

      var hideTimer = null;

      function showLoader() {
        zone.classList.add('is-loading');
      }

      function hideLoader() {
        if (hideTimer) {
          window.clearTimeout(hideTimer);
        }

        hideTimer = window.setTimeout(function () {
          zone.classList.remove('is-loading');
        }, 120);
      }

      function getVisibleSlide() {
        var slides = slideshow.querySelectorAll('.product-main-slide, .product-image-main, .product-single__media, .photoswipe__image, [data-product-single-media-wrapper], [data-media-id]');

        for (var i = 0; i < slides.length; i++) {
          var slide = slides[i];
          var style = window.getComputedStyle(slide);

          if (
            !slide.hasAttribute('hidden') &&
            style.display !== 'none' &&
            style.visibility !== 'hidden' &&
            slide.offsetParent !== null
          ) {
            return slide;
          }
        }

        return slides[0] || null;
      }

      function bindMediaReady(mediaRoot) {
        if (!mediaRoot) {
          hideLoader();
          return;
        }

        var img = mediaRoot.querySelector('img');
        var video = mediaRoot.querySelector('video');
        var iframe = mediaRoot.querySelector('iframe');

        if (video) {
          if (video.readyState >= 2) {
            hideLoader();
          } else {
            showLoader();
            var onVideoReady = function () {
              hideLoader();
              video.removeEventListener('loadeddata', onVideoReady);
              video.removeEventListener('canplay', onVideoReady);
            };
            video.addEventListener('loadeddata', onVideoReady);
            video.addEventListener('canplay', onVideoReady);
          }
          return;
        }

        if (img) {
          if (img.complete && img.naturalWidth > 0) {
            hideLoader();
          } else {
            showLoader();
            var onImgReady = function () {
              hideLoader();
              img.removeEventListener('load', onImgReady);
              img.removeEventListener('error', onImgReady);
            };
            img.addEventListener('load', onImgReady);
            img.addEventListener('error', onImgReady);
          }
          return;
        }

        if (iframe) {
          showLoader();
          var onFrameReady = function () {
            hideLoader();
            iframe.removeEventListener('load', onFrameReady);
          };
          iframe.addEventListener('load', onFrameReady);
          return;
        }

        hideLoader();
      }

      function evaluateActiveMedia() {
        showLoader();
        window.requestAnimationFrame(function () {
          bindMediaReady(getVisibleSlide());
        });
      }

      evaluateActiveMedia();

      root.addEventListener('click', function (event) {
        var thumb = event.target.closest('[data-product-thumb]');
        if (thumb) {
          showLoader();
          window.setTimeout(evaluateActiveMedia, 60);
        }
      });

      slideshow.addEventListener('click', function (event) {
        var trigger = event.target.closest('.flickity-button, .product__thumb-arrow, .slideshow__arrow');
        if (trigger) {
          showLoader();
          window.setTimeout(evaluateActiveMedia, 80);
        }
      });

      if (window.MutationObserver) {
        var observer = new MutationObserver(function () {
          evaluateActiveMedia();
        });

        observer.observe(slideshow, {
          attributes: true,
          childList: false,
          subtree: true,
          attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
        });
      }
    });
  }

  initKsProductMediaLoaders(document);

  document.addEventListener('shopify:section:load', function (event) {
    initKsProductMediaLoaders(event.target);
  });
});